// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from "react";
// This component handles focus-forwarding when navigating through the calendar grid.
// When the customer focuses that component the `next` callback function is called
// with forwards the focus.
export default function TabTrap(_a) {
    var focusNextCallback = _a.focusNextCallback, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    return /*#__PURE__*/ React.createElement("div", {
        tabIndex: disabled ? -1 : 0,
        onFocus: focusNextCallback
    });
} //# sourceMappingURL=index.js.map
